module.exports = __webpack_public_path__ + "static/img/wgt-ab-test.5e6adcb4.png";